import React from "react";
import { ArrowUpRight } from "lucide-react";

const SERVICES = [
  {
    id: "event",
    title: "Event Child Care",
    tag: "Weddings · Conferences · Galas",
    body: "White-glove on-site care for weddings, private parties, and corporate events. Curated activity stations, quiet-time zones, and a fully-managed kid's suite so guests can enjoy the celebration.",
    price: "from $95/hr",
    image:
      "https://images.pexels.com/photos/2909515/pexels-photo-2909515.jpeg?auto=compress&cs=tinysrgb&w=1400",
    span: "md:col-span-2",
    testid: "service-event",
  },
  {
    id: "travel",
    title: "Travel & Hospitality Care",
    tag: "Hotels · Villas · Resorts",
    body: "Premium care in your suite or villa, wherever you're staying. Perfect for family vacations and international travel.",
    price: "from $75/hr",
    image:
      "https://images.unsplash.com/photo-1731336478850-6bce7235e320?auto=format&fit=crop&w=1000&q=80",
    span: "md:col-span-1",
    testid: "service-travel",
  },
  {
    id: "corporate",
    title: "Corporate & Backup Care",
    tag: "Executives · Off-sites · Emergencies",
    body: "Reliable on-demand and backup childcare tailored for busy executives, off-site retreats, and last-minute emergencies.",
    price: "from $60/hr",
    image:
      "https://images.pexels.com/photos/14238073/pexels-photo-14238073.jpeg?auto=compress&cs=tinysrgb&w=1000",
    span: "md:col-span-1",
    testid: "service-corporate",
  },
  {
    id: "custom",
    title: "Care Anywhere Family Concierge",
    tag: "Extended engagements · Multi-child households",
    body: "A dedicated care lead orchestrates every logistical and safeguarding detail — from extended stays and multi-family gatherings to complex international itineraries — delivering seamless continuity from arrival to departure.",
    price: "Custom quote",
    image:
      "https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&w=1400&q=80",
    span: "md:col-span-2",
    testid: "service-custom",
  },
];

const ServiceCard = ({ s }) => (
  <a
    href="#inquire"
    data-testid={s.testid}
    className={`group relative overflow-hidden rounded-2xl border border-border/80 ${s.span} min-h-[320px] md:min-h-[380px] block`}
  >
    <img
      src={s.image}
      alt={s.title}
      className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1200ms] group-hover:scale-105"
      loading="lazy"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-foreground/85 via-foreground/40 to-foreground/10" />
    <div className="relative h-full flex flex-col justify-end p-7 md:p-9 text-primary-foreground">
      <div className="text-[11px] tracking-[0.22em] uppercase text-white/80">
        {s.tag}
      </div>
      <h3 className="mt-3 font-serif-display text-2xl md:text-3xl leading-tight text-white">
        {s.title}
      </h3>
      <p className="mt-3 text-sm text-white/85 max-w-md leading-relaxed">
        {s.body}
      </p>
      <div className="mt-6 inline-flex items-center gap-2 text-sm text-white">
        Enquire
        <ArrowUpRight
          size={16}
          className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
        />
      </div>
    </div>
  </a>
);

const Services = () => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 lg:py-32 bg-muted/40"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <div className="text-xs tracking-[0.25em] uppercase text-primary/80">
              Our Services
            </div>
            <h2 className="mt-4 font-serif-display text-4xl sm:text-5xl leading-[1.1] tracking-tight text-foreground">
              Care that arrives with the moment.
            </h2>
          </div>
          <p className="max-w-md text-muted-foreground leading-relaxed">
            Discreet, professional, and endlessly adaptable — every engagement
            is scoped to your family, your schedule, and your setting.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {SERVICES.map((s) => (
            <ServiceCard key={s.id} s={s} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
